import { ConfirmModal } from '../../commons/components/ConfirmModal';
import React from 'react';
import { ReleasePromptData } from '../types';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import {
  ReleaseContentBusinessPlan,
  ReleaseContentMobileApp,
  ReleaseContentPersonalReferralLink,
  RELEASE_PROMPT_CODE_BUSINESS_PLAN,
  RELEASE_PROMPT_CODE_MOBILE_APP,
  RELEASE_PROMPT_CODE_PERSONAL_REFERRAL_LINK,
  RELEASE_PROMPT_CODE_FUNDING,
  ReleaseContentFunding,
} from './ReleasePromptContent';

export const ReleasePromptDialog = (props: {
  prompt: ReleasePromptData;
  onNavigate: () => void;
  onCancel: () => void;
  onCheckLater: () => void;
}) => {
  const { prompt, onNavigate, onCancel, onCheckLater } = props;
  useAnalyticsPage(Page.RELEASE_PROMPT, { promptCode: prompt.code });
  return (
    <ConfirmModal
      title={prompt.title}
      ariaHideApp={false}
      footer={{
        type: 'show',
        applyButton: prompt.route
          ? {
              label: prompt.route ? 'Explore' : 'Close',
              onClick: onNavigate,
            }
          : undefined,
        cancelButton: {
          label: 'Skip',
          onClick: onCancel,
        },
        extraButtons: [
          {
            label: 'Check later',
            onClick: onCheckLater,
          },
        ],
      }}
    >
      {prompt.code === RELEASE_PROMPT_CODE_BUSINESS_PLAN ? (
        <ReleaseContentBusinessPlan />
      ) : prompt.code === RELEASE_PROMPT_CODE_MOBILE_APP ? (
        <ReleaseContentMobileApp />
      ) : prompt.code === RELEASE_PROMPT_CODE_PERSONAL_REFERRAL_LINK ? (
        <ReleaseContentPersonalReferralLink />
      ) : prompt.code === RELEASE_PROMPT_CODE_FUNDING ? (
        <ReleaseContentFunding onNavigate={onNavigate} />
      ) : null}
    </ConfirmModal>
  );
};
